import { EnumResolver } from "../../../../common/tables/etc/EnumResolver";
import { CostMetadataTableRow } from "../../../../../../common/tables/cost-metadata/CostMetadataTableRow";
import { EnumMapper } from "../../../../common/tables/etc/EnumMapper";

export class CostMetadataEnumMapper extends EnumResolver<CostMetadataTableRow> {
    public resolveEnum(_columnName: keyof CostMetadataTableRow): EnumMapper {
        return {} as EnumMapper;
    }
}
